import React, { memo } from 'react';

import styles from './CompilationsSection.css';
import type { IProps } from './CompilationsSection.types';

const title = 'Подборки';

export const CompilationsSection = memo(function CompilationsSection(props: IProps) {
    const { children } = props;

    return (
        <section className={styles.root} data-qa-id="compilations-section" data-qa-title={title}>
            <div className={styles.title} data-qa-id="compilations-section-title">
                {title}
            </div>
            <div className={styles.section} data-qa-id="compilations-section-layout" data-qa-title={title}>
                {children}
            </div>
        </section>
    );
});
